import { Injectable } from '@angular/core';
import { CatalogueFilters } from 'src/app/core/models/catalogue-filters';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { LabelType } from '@angular-slider/ngx-slider';
export interface SearchParam {
  name: string;
  value: any;
  selected?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class DataService {
  private dataDates: SearchParam[] = [];
  private promotions: SearchParam[] = [];
  private dataCategories: SearchParam[] = [];
  private dataAmenities: SearchParam[] = [];
  selectedDepartureObj: any = {};
  currntMonth: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  configPriceobject= {
    floor: 0,
    ceil: 30000,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return (
            "<b style='font-family: Poppins, sans-serif; font-size:12.8px'>From:</b>US$ " +
            value.toLocaleString('en', { maximumFractionDigits: 2 })
          );
        case LabelType.High:
          return (
            "<b style='font-family: Poppins, sans-serif; font-size:12.8px'>To:</b>US$ " +
            value.toLocaleString('en', { maximumFractionDigits: 2 })
          );
        default:
          return '$' + value.toLocaleString('en', { maximumFractionDigits: 2 });
      }
    }
  }

  constructor() {
    this.fetchAmenities();
  }

  fetchDates(auxYear: number, months: any[]) {
    this.selectedDepartureObj.year = auxYear;
    this.dataDates = [];
    months.forEach((valueMonth) => {
      if (valueMonth > 0) {
        this.dataDates.push({
          name: `${this.currntMonth[Number(valueMonth) - 1]}, ${auxYear}`,
          value: this.generateDateByStringYearAndMonthDate(
            `${valueMonth}, ${auxYear}`
          ).getTime(),
        });
      }
    });
    return this.dataDates;
  }

  public generateDateByStringYearAndMonthDate(stringDate: string): Date {
    const dateArray = stringDate.split(',');
    if (dateArray.length >= 2) {
      const year = Number(dateArray[1]);
      const month = Number(dateArray[0]);
      if (
        Number.isSafeInteger(year) &&
        Number.isSafeInteger(month) &&
        month >= 1 &&
        month <= 12
      ) {
        return UtilsService.generateDateByYearAndMonth(year, month);
      }
    }
    return new Date();
  }

  fetchCategories(categories: CatalogueFilters[], urlCategories: string) {
    this.dataCategories = [];
    categories.map((item) => {
      if (item.status) {
        let aux = {
          name: item.label,
          value: item.value,
          selected: this.isSelected(item, urlCategories),
        };
        this.dataCategories.push(aux);
      }
    });
  }

  getCategoryByName(name:string):any{
    let category = "";
    const words = name.split(" ");
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    words.join(" ");
    this.dataCategories.forEach((cat)=>{
      if(cat.name == words.toString().replace(","," ")){
        category = cat.value;
      };
    })
    return category;
  }

  isSelected(item: CatalogueFilters, urlCategories: string): boolean {
    let categoriesInURL =
      this.isNullOrUndefined(urlCategories) || urlCategories === ''
        ? []
        : urlCategories.split(',');
    const index = categoriesInURL.findIndex(
      (itemCategory) => itemCategory === String(item.value)
    );
    return index >= 0;
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

  fetchPromotions(promos: CatalogueFilters[]) {
    this.promotions = [];
    promos.map((item) => {
      if (item.status) {
        this.promotions.push({
          name: item.label,
          value: item.value,
          selected: false,
        });
      }
    });
  }

  fetchAmenities() {
    this.dataAmenities = [
      { name: 'Boutique', value: '2068' },
      { name: 'Cruise Manager', value: '2052' },
      { name: 'DVD TV', value: '2066' },
      { name: 'Fitness Center', value: '2056' },
      { name: 'Free alcoholic drinks', value: '2058' },
      { name: 'Glass bottom boat', value: '2069' },
      { name: 'Green politics', value: '2062' },
      { name: 'Jacuzzi', value: '2057 ' },
      { name: 'Kayaks', value: '2060 ' },
      { name: 'Laundry', value: '2055' },
      { name: 'Library', value: '2065' },
      { name: 'Private Balconies', value: '2059' },
      { name: 'Room Service', value: '2063' },
      { name: 'Satellital Phone', value: '2054' },
      { name: 'Snorkeling equipment', value: '2067' },
      { name: 'Spa', value: '2064' },
      { name: 'Wetsuit', value: '2070' },
      { name: 'Stand-up paddle', value: '2061' },
      { name: 'WiFi', value: '2053' },
      { name: 'Hairdryer', value: '2071' },
    ];
  }

  public getAmenityByCode(value:any):string{
    let amenityString = "";
    this.fetchAmenities();
    let amenitiesList = this.dataAmenities;
    amenitiesList.forEach((amenity:any)=>{
      if(value == amenity.value ){
        amenityString = amenity.name;
      }
    });
    return amenityString;
  }

  public getAmenityByName(name:any):string{
    let amenityString = "";
    this.fetchAmenities();
    let amenitiesList = this.dataAmenities;
    amenitiesList.forEach((amenity:any)=>{
      if(name == amenity.name ){
        amenityString = amenity.value;
      }
    });
    return amenityString;
  }

  public getDates(): SearchParam[] {
    try {
      const today = new Date();
      const auxString = today.getMonth() + 1 + ',' + today.getFullYear();
      const aux =
        this.generateDateByStringYearAndMonthDate(auxString).getTime();
      let resp: any = [];

      this.dataDates.forEach((item) => {
        if (item.value >= aux) {
          resp.push(item);
        }
      });
      return resp;
    } catch (error) {
      return [];
    }
  }

  public getSelectedDepartureObj(): any {
    return this.selectedDepartureObj;
  }

  fetchPromos(codes: string[]): SearchParam[] {
    return this.promotions.map((item) => {
      let index = codes.findIndex(
        (code) => String(code) === String(item.value)
      );
      if (index >= 0) {
        return { ...item, selected: true };
      } else {
        return { ...item };
      }
    });
  }

  public getPromotions(): SearchParam[] {
    return this.promotions;
  }

  public getCategories(): SearchParam[] {
    return this.dataCategories;
  }

  public getAmenities(): SearchParam[] {
    return this.dataAmenities;
  }
}
